// extracted by css-extract-rspack-plugin
export default {"truncate":"wd5PCkBNOAhbXyQu"};